import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-countdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './double-authentication-countdown.component.html',
  styleUrl: './double-authentication-countdown.component.scss',
})
export class CountdownComponent implements OnInit {
  countdown = 300;
  displayTime = '05:00';
  private timer: any;
  @Output() countdownFinished = new EventEmitter<void>();

  ngOnInit(): void {
    this.startCountdown();
  }

  startCountdown(): void {
    this.timer = setInterval(() => {
      this.countdown--;
      this.updateDisplayTime();

      if (this.countdown <= 0) {
        clearInterval(this.timer);
        this.displayTime = '00:00';
        this.countdownFinished.emit();
      }
    }, 1000);
  }

  updateDisplayTime(): void {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;
    this.displayTime = `${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }
}
